import Autocomplete from './autocomplete';
import CarParkList from './car_park_list';
import MapManager from './map_manager';

export default class RegionSelect {
  static init() {
    self.select = document.querySelector("#region-select");

    {
      // @Note selectpicker used to be initialized in a separate script file.
      // But due to some timing bug it has, sometimes it didn't emit change
      // events to the select input, mostly when using the browser's back-forward
      // actions.
      //
      // As an easy fix, I moved it here; the bug doesn't trigger due to
      // RegionSelect initializing a bit later since it waits for the google
      // maps scripts to load first.
      //
      // This is not a real solution, but I'm ok with it, since the whole
      // homepage UI is planned to be remade "soon", and selectpicker will
      // probably be completely removed anyway.
      //
      if ( $(window).width() <= 768 ) {
        $('.selectpicker').selectpicker({
          width: "100%",
          mobile: "true"
        });
      } else {
        $('.selectpicker').selectpicker({
          width: "100%",
          container: "#search-box-wrapper"
        });
      }
    }

    self.injectClearButtonToSelectPicker();

    self.select.addEventListener("change", () => {
      Autocomplete.clearSearch();
      self.handleRegionChange()
    });
  }

  static setRegion(regionId) {
    $(self.select).selectpicker("val", regionId);
    self.handleRegionChange();
  }

  static handleRegionChange() {
    const regionId = self.select.selectedOptions[0].value;

    MapManager.focusMarker(null);

    if ( regionId == null || regionId === "" ) {
      self.toggleRegionClear(false);
      MapManager.filterMarkersByRegion(null);
      CarParkList.clearList();
    } else {
      self.toggleRegionClear(true);
      MapManager.filterMarkersByRegion(regionId);
      CarParkList.loadList({ region_id: regionId });
    }

    MapManager.centerMarkers();
    MapManager.setSearchMarker(0, 0, false);
  }

  // @Note Adds a button inside the selectpicker element that clears it when clicked
  static injectClearButtonToSelectPicker() {
    const clearBtnClass = "clear-region-btn";

    self.clearBtn = document.createElement("span");
    self.clearBtn.classList.add(clearBtnClass, "cityzen-icon", "cityzen-icon--clear-search");
    self.clearBtn.hidden = true;

    const spDropdown = document.querySelector(".dropdown");
    const spSelect   = spDropdown.querySelector(".bootstrap-select");

    spSelect.insertAdjacentElement("beforebegin", self.clearBtn);
    spDropdown.addEventListener("click", (e) => {
      const clearBtn = e.target.closest(`.${clearBtnClass}`);
      if ( clearBtn ) {
        e.stopPropagation();
        Autocomplete.clearSearch();
        self.setRegion(null);

        return;
      }
    });
  }

  static toggleRegionClear(show) {
    self.clearBtn.hidden = !show;
  }
}

const self = RegionSelect;
